import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@chegg-ui/theme'
import Image from 'next/image'
import { fanta } from '@chegg/fanta'

const ProTipContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  background-color: ${colors.skyXlight};
  padding: ${fanta.spacing.md};
  margin: ${fanta.spacing.md} auto;
  width: 100%;
`

const ProtipText = styled.div`
  font-size: ${fanta.font.size.sm};
  display: table-cell;
`

const ProTip = styled.span`
  font-weight: ${fanta.font.weight.bold};
  font-size: ${fanta.font.size.xxs};
`

const ProTipContents = styled.div`
  vertical-align: middle;
  margin-left: ${fanta.spacing.sm};
`

const ProtipRemainingText = styled.span`
  color: ${colors.dark};
  font-size: ${fanta.font.size.xxs};
`

export const FEATHER_ALT = 'feather'
export const PRO_TIP = 'Pro tip:'

interface ProtipProps {
  protipCopyText: string
  protipHeaderText?: string
  imgSrc: string
}

export const Protip: React.FunctionComponent<ProtipProps> = ({
  protipCopyText,
  protipHeaderText,
  imgSrc,
}) => (
  <ProTipContainer>
    <Image src={imgSrc} alt={FEATHER_ALT} width={55} height={55} />
    <ProtipText>
      <ProTipContents>
        <ProTip>{protipHeaderText || PRO_TIP}&nbsp;</ProTip>
        <ProtipRemainingText>{protipCopyText}</ProtipRemainingText>
      </ProTipContents>
    </ProtipText>
  </ProTipContainer>
)
